export const OrganizationTypes = [
  {
    value: 'customer',
    label: 'Customer',
  },
  {
    value: 'utility',
    label: 'Utility',
  },
  {
    value: 'teo',
    label: 'Attributes',
  },
];



// WEBPACK FOOTER //
// ./src/constants/OrganizationTypes.js